import { t as tr } from '@hana/i18n';
import './InvPad.i18n';
import { IconArrowsExchange, IconCheck, IconPinned } from '@tabler/icons-react';
import { Button, useToast } from '@hana/ui';
import type { SupplierInvoice } from './types';
import { f1 } from './view';
import s from './invPad.module.css';

// Mint-Cost-iPad › tab HĐ đối tác: thẻ 2 cột (mã · đối tác, số tiền, kiểm hoá đơn, trạng thái duyệt). Chỉ đọc; nút ghi báo toast.

/** Thứ tự + dòng ghép theo board (`INV`), khớp mã HĐ trong dữ liệu mẫu. */
const PAD_INV: readonly (readonly [id: string, mk: string, kind?: 'repl' | 'bad'])[] = [
  ['PI26097303', '6/6 dòng đã ghép'],
  ['PI26097302', '2/3 dòng · tổng dòng lệch 0,4 tr'],
  ['PI26097301', '4/4 dòng · B/L COSU6470825400'],
  ['PI26097297', '14 lượt khớp chuyến GPS'],
  ['PI26097290', 'Thay thế 1/C26TOL/88120 · SE260608050 đã duyệt costing', 'repl'],
  ['PI26097298', 'Đối tác mới · chưa có Ref/BL', 'bad'],
];

export function InvPad({ invoices, q }: { invoices: readonly SupplierInvoice[]; q: string }) {
  const toast = useToast();
  const noWrite = () => toast({ msg: 'Chưa mở ghi ở bản này' });
  const byId = new Map(invoices.map((r) => [r.id, r]));
  const cards = PAD_INV.flatMap(([id, mk, kind]) => {
    const r = byId.get(id);
    return r ? [{ r, mk, kind }] : [];
  }).filter(({ r }) => !q.trim() || `${r.id} ${r.partner} ${r.partnerName} ${r.invNo}`.toLowerCase().includes(q.trim().toLowerCase()));

  return (
    <div className={s.grid}>
      {cards.map(({ r, mk, kind }) => {
        const ok = r.check === 'Hóa đơn hợp lệ';
        const chip = ok ? s.cOk : kind === 'bad' ? s.cErr : s.cWarn;
        return (
          <section key={r.id} className={s.card} aria-label={`Hoá đơn ${r.id}`}>
            <div className={s.top}>
              <b className={s.no}>
                {r.id} · {r.partner}
              </b>
              <b className={s.amt}>{f1(r.amount)} tr</b>
            </div>
            <div className={s.sub}>
              {r.invNo} · {r.date} · {r.group}
            </div>
            <div className={s.chips}>
              <span className={`${s.chip} ${chip}`}>{r.check}</span>
              <span className={s.mk}>{mk}</span>
            </div>
            <div className={s.appr} style={{ color: r.approver ? 'var(--ok)' : 'var(--warn)' }}>
              {r.approver ? `Phê duyệt · ${r.approver}` : 'Chưa duyệt · [ACC-CP] thẩm quyền INVOICE-IN-POST'}
            </div>
            {kind !== 'repl' && kind !== 'bad' && (
              <Button
                variant={r.approver ? 'secondary' : 'primary'}
                className={s.act}
                icon={r.approver ? undefined : <IconCheck size={16} aria-hidden="true" />}
                onClick={noWrite}
              >
                {r.approver ? 'Bỏ duyệt' : 'Duyệt'}
              </Button>
            )}
            {kind === 'bad' && <div className={s.bad}>Kiểm meInvoice: {r.check} — sửa hoặc tạo đối tác trước khi duyệt</div>}
            {kind === 'repl' && (
              <div className={s.row}>
                <Button variant="primary" icon={<IconArrowsExchange size={16} aria-hidden="true" />} onClick={noWrite}>
                  {tr('ipad.1')}
                </Button>
                <Button icon={<IconPinned size={16} aria-hidden="true" />} onClick={noWrite}>
                  {tr('ipad.2')}
                </Button>
              </div>
            )}
          </section>
        );
      })}
    </div>
  );
}
